import React, { type FunctionComponent } from 'react';
import { Result } from 'antd';
import styled from "styled-components";
import { Logout } from "~/Logout";

const LogoutWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin: 10px 10px 0 0;
`;

export const UnauthorizedSplash: FunctionComponent = () => {
    return (
      <>
        <LogoutWrapper><Logout /></LogoutWrapper>
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this application."
        />
      </>
    )
}
